import React, { useState } from "react";
import "../styles/ResetPassword.css";
import config from "../services/config";
import { showAlert } from "../utilities/alertService";
import Loader from "../utilities/Loader";

export default function ResetPassword({ onClose, onOtpVerified }) {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [token, setToken] = useState("");
  const [step, setStep] = useState("email"); // "email" → "otp"
  const [loading, setLoading] = useState(false);

  const handleSendOtp = async () => {
  if (!email) {
    showAlert("warning", "Please enter your email.");
    return;
  }

  try {
    setLoading(true);
    const response = await config.customerRequestReset({ email });

    if (response.status === 200) {
      showAlert("success", response.message || "OTP sent to your email!");
      setStep("otp"); // ✅ Only move to OTP step if successful
    } else {
      showAlert("error", response.message || "Failed to send OTP!");
    }
  } catch (error) {
    console.error("Error sending OTP:", error);
    showAlert("error", "Something went wrong while sending OTP. Please try again.");
  } finally {
    setLoading(false);
  }
};

  const handleVerifyOtp = async () => {
    if (!otp) {
      showAlert("warning", "Please enter the OTP.");
      return;
    }
    try {
      setLoading(true);
      const response = await config.customerVerifyOtp({ email, otp });
      if (response.status === 200) {
        localStorage.setItem("email", email);
        localStorage.setItem("reset_token", response.reset_token);
        onClose();       // close ForgotPassword
        onOtpVerified(); // open NewPassword
      } else {
        alert(response.message || "Invalid OTP. Please try again.");
      }

      // ✅ temp fallback until API is integrated
      onClose();
      onOtpVerified();

    } catch (error) {
      console.error("Error verifying OTP:", error);
      showAlert("error", "Something went wrong while verifying OTP. Please try again.");
    }
    finally {
      setLoading(false);
    }
  };


  return (
    <div className="forgot-overlay">
      <div className="forgot-box">
        <span className="close-btn" onClick={onClose}>✖</span>
        <h2>Reset Password</h2>
        {loading && <Loader />}
        {step === "email" && (
          <div className="form-group">
            <input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button onClick={handleSendOtp}>Send OTP</button>
          </div>
        )}

        {step === "otp" && (
          <div className="form-group">
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <button onClick={handleVerifyOtp}>Verify OTP</button>
          </div>
        )}
      </div>
    </div>
  );
}
